import React from 'react';
import { observer } from 'mobx-react';

import { useFacility } from 'app/facility';

import TextField from 'app/commonComponents/TextField';
import form from 'modules/ticketPublicPage/stores/tickets/form';
import view from 'modules/ticketPublicPage/stores/tickets/view';
import { colors } from 'app/variables';
import NewsletterCheckbox from '../common/_newsletterCheckbox';
import { CheckboxContainer } from '../common/styles';
import {
  Container,
  BuyForm,
  DetailsForm,
  PhoneInput,
  NameFieldWrapper,
} from './styles/_details';
import DetailsContainer from './DetailsContainer';
import ActionButtons from './common/ActionButtons';

export const textFieldLabelStyle = {
  fontSize: '0.6rem',
  fontWeight: 'initial',
  color: colors.dustyGray,
};

const inputStyle = {
  borderBottom: '1px solid inherit',
  padding: '0.6rem 0.3rem',
  borderRadius: 'initial',
};

const Details = observer(() => {
  const facility = useFacility();
  const {
    formValues,
    errors,
    setFormValue,
    setValidPhone,
    stashedPhoneNumber,
    validateField,
  } = form;
  const { activeObject } = view;
  const { type } = activeObject;

  const isEventPage = type === 'event';
  return (
    <BuyForm style={{ height: '100%' }}>
      <Container>
        <div>
          <DetailsContainer />
          <DetailsForm>
            <NameFieldWrapper
              direction={isEventPage ? 'horizontal' : 'vertical'}
            >
              <TextField
                required
                labelStyle={textFieldLabelStyle}
                data-testid="first_name_input"
                label={
                  <div>
                    <span>{i18n.gettext('First name')}</span>
                    <span aria-hidden="true">*</span>
                  </div>
                }
                placeHolder={i18n.gettext('e.g. John')}
                onChange={(e) => setFormValue('name', e.target.value)}
                onBlur={() => validateField('name')}
                value={formValues.get('name')}
                name="name"
                error={errors.get('name')}
                inputStyle={inputStyle}
                style={{ width: '100%' }}
              />
              <TextField
                required
                labelStyle={textFieldLabelStyle}
                data-testid="last_name_input"
                label={
                  <div>
                    <span>{i18n.gettext('Last name')}</span>
                    <span aria-hidden="true">*</span>
                  </div>
                }
                placeHolder={i18n.gettext('e.g. Doe')}
                onChange={(e) => setFormValue('surname', e.target.value)}
                onBlur={() => validateField('surname')}
                value={formValues.get('surname')}
                name="surname"
                error={errors.get('surname')}
                inputStyle={inputStyle}
                style={{ width: '100%' }}
              />
            </NameFieldWrapper>
            <TextField
              required
              labelStyle={textFieldLabelStyle}
              data-testid="email_input"
              label={
                <div>
                  <span>{i18n.gettext('Email')}</span>
                  <span aria-hidden="true">*</span>
                </div>
              }
              placeHolder={i18n.gettext('e.g. example@email.com')}
              onChange={(e) => setFormValue('email', e.target.value)}
              onBlur={() => validateField('email')}
              value={formValues.get('email')}
              name="email"
              error={errors.get('email')}
              inputStyle={inputStyle}
            />
            {isEventPage ? (
              <PhoneInput
                required
                label={i18n.gettext('Phone*')}
                defaultValue={stashedPhoneNumber}
                defaultCountry={facility.settings.country}
                setValidPhone={setValidPhone}
                setPhoneNumber={(value) => setFormValue('phone', value)}
                onBlur={() => validateField('phone')}
                placeholder={i18n.gettext('e.g. (0)151 1234567')}
                error={errors.get('phone')}
                labelStyle={textFieldLabelStyle}
                inputProps={{ 'data-testid': 'phone_input' }}
              />
            ) : null}
            <CheckboxContainer style={{ marginTop: '2.5rem' }}>
              <NewsletterCheckbox
                checked={formValues.get('newsletter_subscribe')}
                onChange={(checked) =>
                  setFormValue('newsletter_subscribe', checked)
                }
              />
            </CheckboxContainer>
          </DetailsForm>
        </div>
      </Container>
      <ActionButtons />
    </BuyForm>
  );
});

export default Details;
